// extracted by mini-css-extract-plugin
export default {"root":"nav-item_root__foFpu","active":"nav-item_active__7yNBv"};